/** Etiqueta accesible por defecto del `<nav>` del breadcrumb. */
export const DEFAULT_ARIA_LABEL = 'Ruta de navegación'

/** Tamaño en px del icono separador (chevron). */
export const SEPARATOR_ICON_SIZE = 10
